import { Component, Vue, Inject } from 'vue-property-decorator';
import FieldValidationErrors from '@/components/errors/FieldValidationErrors.vue';

@Component({
    name: 'TermsAndConditions',
    components: {
        FieldValidationErrors
    }
})
export default class TermsAndConditionsInput extends Vue {

    @Inject('validator')
    $validator: any;

    agreesToTerms: boolean = false;

    created() {
        this.$validator.extend('agreeToTerms', {
            getMessage: () => 'You must agree to terms & conditions to continue.',
            validate: (value: boolean) => value
        }, { validatesRequired: true });
    }
}